import { render, staticRenderFns } from "./StagingLabel.vue?vue&type=template&id=2f612fd9&scoped=true&"
import script from "./StagingLabel.vue?vue&type=script&lang=js&"
export * from "./StagingLabel.vue?vue&type=script&lang=js&"
import style0 from "./StagingLabel.vue?vue&type=style&index=0&id=2f612fd9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f612fd9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
